exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.b-adori-red[data-v-5e0d756e] {\n  border: #de1a23 solid 0.2rem;\n}\n.backButton[data-v-5e0d756e] {\n  position: relative;\n  top: 18px;\n  left: 15px;\n}\n.backImage[data-v-5e0d756e] {\n  position: relative;\n  left: -4px;\n}\n.b-red[data-v-5e0d756e] {\n  border-color: #de1a23;\n}\n.btn-hover[data-v-5e0d756e]:hover {\n  border-color: #6e6e6e;\n  border-style: solid;\n  border-width: 1px;\n}\n", ""]);

// exports
